<template>
  <div class="page-main">
    <div class="myHead">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/processManager/warehouseArea' }">仓库信息</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.params.id ? '编辑' : '新增'}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="myBody">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="180px"
        size="small" style="width: 70%; margin: auto">
        <el-form-item label="库区编号" prop="serialNum">
          <el-input v-model="ruleForm.serialNum" />
        </el-form-item>
        <el-form-item label="库区名称" prop="name">
          <el-input v-model="ruleForm.name" />
        </el-form-item>
        <el-form-item label="在厂区的位置" prop="locationForFactory">
          <el-input v-model="ruleForm.locationForFactory" />
        </el-form-item>
        <el-form-item label="所处环境功能区" prop="environmentFunction">
          <el-input v-model="ruleForm.environmentFunction" />
        </el-form-item>
        <el-form-item label="库区面积" prop="acreage">
          <el-input v-model="ruleForm.acreage" type="number">
            <template slot="append">平方米</template>
          </el-input>
        </el-form-item>
        <el-form-item label="库房个数" prop="warehouseNum">
          <el-input v-model="ruleForm.warehouseNum" type="number">
            <template slot="append">个</template>
          </el-input>
        </el-form-item>
        <el-form-item label="相邻库房最小间距" prop="adjacentMinimumDistance">
          <el-input v-model="ruleForm.adjacentMinimumDistance" type="number">
            <template slot="append">米</template>
          </el-input>
        </el-form-item>
        <el-form-item label="所属危险化学品重大危险源编码" prop="hazardousChemicalSerial">
          <el-input v-model="ruleForm.hazardousChemicalSerial" placeholder="企业编码(9 位）+3 位流水号" />
        </el-form-item>
        <el-form-item label="现场照片">
          <el-upload
            class="avatar-uploader"
            action="/v1/trainMaterials/uploadFile"
            :show-file-list="false"
            :on-success="handleAvatarSuccess">
            <img v-if="ruleForm.localePhoto" :src="host + ruleForm.localePhoto" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
<!--        <el-form-item label-width="0">
          <el-col :span="12">
            <el-form-item label="经度" prop="longitude">
              <el-input v-model="ruleForm.longitude" type="number">
                <template slot="append">度</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="纬度" prop="latitude">
              <el-input v-model="ruleForm.latitude" type="number">
                <template slot="append">度</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-form-item>-->
        <el-form-item label="备注">
          <el-input v-model="ruleForm.remarks" type="textarea" :rows="2" />
        </el-form-item>
        <el-form-item class="form-item-button">
          <el-button type="primary" @click="submit">保存</el-button>
          <el-button type="danger" @click="$router.back()">返回</el-button>
        </el-form-item>
      </el-form>  
    </div>
  </div>
</template>

<script>
  import { warehouseAreaAdd, warehouseAreaEdit } from "@/api/majorHazard"
  export default {
    name: "warehouseArea",
    data() {
      return {
        ruleForm: {},
        rules: {
          serialNum: [{ required: true, message: '请输入' }],
          name: [{ required: true, message: '请输入' }],
          locationForFactory: [{ required: true, message: '请输入' }],
          environmentFunction: [{ required: true, message: '请输入' }],
          acreage: [{ required: true, message: '请输入' }],
          warehouseNum: [{ required: true, message: '请输入' }],
          adjacentMinimumDistance: [{ required: true, message: '请输入' }],
          hazardousChemicalSerial: [{ required: true, message: '请输入' }],
          longitude: [{ required: true, message: '请输入' }],
          latitude: [{ required: true, message: '请输入' }],
        },
      }
    },
    created() {
      if(this.$route.params.id) {
        this.ruleForm = this.$route.params
      }
    },
    methods: {
      // 上传的事件
      handleAvatarSuccess(res, file) {
        this.$set(this.ruleForm, 'localePhoto', res.data)
      },
      // 保存
      submit() {
        this.$refs['ruleForm'].validate((valid) => {
          if(valid) {
            // 编辑
            if(this.$route.params.id) {
              warehouseAreaEdit(this.ruleForm).then(res => {
                this.$message.success('保存成功')
                this.$router.push('/processManager/warehouseArea')
              })
            } else {
              // 新增
              warehouseAreaAdd(this.ruleForm).then(res => {
                this.$message.success('保存成功')
                this.$router.push('/processManager/warehouseArea')
              })
            }
          }else{
            return false
          }
        })
      }
    }
  }
</script>

<style scoped lang="scss">
  .page-main {
    height: 100%;
  }
  .myHead {
    position: absolute;
    top: 0;
    left: 250px;
    width: calc(100% - 250px);
    padding: 20px;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .myBody {
    background-color: #ffffff;
    height: 100%;
    overflow: scroll;
    padding: 20px;
    .body-head {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .search-input {
        .search-btn {
          background-color: #409EFF;
          color: #fff;
          /*border-color: #409EFF;*/
        }
      }
    }
    .body-main {
      margin-top: 20px;
    }
    .el-form-item {
      .item-btn {
        display: flex;
        align-items: center;
        .btn {
          margin-left: 20px;
        }
      }
      .el-select {
        width: 100%;
      }
    }
    .form-item-button {
      display: flex;
      justify-content: center;
    }
  }
</style>
